<template>
    <div></div>
</template>
<script>
export default {
    name: 'Dashboard',
    components: {},
    props: {},
    data() {
        return {};
    },
};
</script>
